import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { faAdd, faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';
import ButtonOptionGroup from '../../../ERPPPSU/component/ButtonOptions/ButtonOption';
import { getToken } from '../../../../helpers/Jwt';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const ManageUnits = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(true);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_UNITS = "api/rentcar/dashboard/unit";

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_UNITS}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            },
            params: {
                offset: pageIndex,
                limit: pageSize
            }
        }).then((data) => {
            setData(data.data);
        });
    }, []);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const options = [
        { value: 'new', label: 'Buat Baru' }
    ];

    const handleEdit = (rowData) => {
        navigate(`/activity-rentcar/entry-unit/${rowData.id.value}`);
    };

    const actions = [
        {
        child: <button className='text-white text-xs rounded focus:ring bg-yellow-500 hover:bg-yellow-700 p-2 mx-1'>
            <FontAwesomeIcon icon={faEdit} color="white" />Ubah
        </button>,
        callback: (rowData) => handleEdit(rowData)
    }];

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className='flex items-center justify-between'>
                <h2 className="text-2xl font-bold mb-4">Harga</h2>

                <div className='flex items-center'>
                    <ButtonOptionGroup
                        label={"Tindakan"}
                        options={options}
                        onChange={(value) => {
                            navigate(`/activity-rentcar/entry-unit`);
                        }}
                    />
                </div>
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTablePageDynamic
                    data={data}
                    nextPage={isNextPage}
                    columns={columns}
                    elementClass="p-1"
                    actions={actions}
                    onDataChange={(pageIndex, pageSize, sortBy) => {
                        fetchData(`${BASE_URL}${PATH_UNITS}`, {
                            headers: {
                                Authorization: `Bearer ${getToken()}`,
                                "Content-Type": "application/json"
                            },
                            params: {
                                offset: pageIndex,
                                limit: pageSize
                            }
                        }).then((data) => {
                            setIsNextPage(data.more > 0);
                            setData(data.data);
                        });
                    }} />
            )}
        </div>
    )
}

export default ManageUnits;
